type Locale = "fr" | "en";

interface AppConfig {
  VITE_API_BASE_URL: string;
  VITE_API_OBFUSCATION_ENABLED: string;
  VITE_API_OBFUSCATION_KEY: string;
  VITE_DEFAULT_LOCALE: Locale;
  VITE_FALLBACK_LOCALE: Locale;
  VITE_CAPTCHA: string;
  VITE_GOOGLE_MAPS_API_KEY: string;
  VITE_CALENDLY_URL: string;
  VITE_DSN_SENTRY: string;
  VITE_SENTRY_ENVIRONMENT: string;
  VITE_TRACES_SAMPLE_RATE: string;
  VITE_REPLAYS_SESSION_SAMPLE_RATE: string;
  VITE_REPLAYS_ON_ERROR_SAMPLE_RATE: string;
  VITE_ZENDESK_URL: string;
  VITE_ZENDESK_CHAT_URL: string;
}

declare global {
  interface Window {
    APP_CONFIG?: Partial<AppConfig>;
  }
}

const defaultAppConfig: AppConfig = {
  VITE_API_BASE_URL: "http://localhost:5000",
  VITE_API_OBFUSCATION_ENABLED: "false",
  VITE_API_OBFUSCATION_KEY: "",
  VITE_DEFAULT_LOCALE: "fr",
  VITE_FALLBACK_LOCALE: "en",
  VITE_CAPTCHA: "",
  VITE_GOOGLE_MAPS_API_KEY: "",
  VITE_CALENDLY_URL:
    "https://calendly.com/boomerang_formation/formation-initiale",
  VITE_DSN_SENTRY: "",
  VITE_SENTRY_ENVIRONMENT: "local",
  VITE_TRACES_SAMPLE_RATE: "0",
  VITE_REPLAYS_SESSION_SAMPLE_RATE: "0",
  VITE_REPLAYS_ON_ERROR_SAMPLE_RATE: "0",
  VITE_ZENDESK_URL: "",
  VITE_ZENDESK_CHAT_URL: "",
};

export const appConfig: AppConfig = {
  ...defaultAppConfig,
  ...window.APP_CONFIG,
};
